import React, { useEffect, useState } from "react"
import { TextArea, TextBox} from 'devextreme-react';
import SelectBox from "../../../../common/CustomSelectBox"
import { useDispatch, useSelector } from "react-redux";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/selectors";

function ItvForm(props){
const {classes, onChange, dataForm, template} = props;
const dispatch = useDispatch();
const types = useSelector(selectTaxonomyTemplates);
const [type, setType] = useState(dataForm?.templateCode)


useEffect(()=>{
    dispatch(getTaxonomyTemplates({query: "?templateCode=" + template?.code}))
},[])

useEffect(()=>{
    if(type && types.length > 0){
    onChange("templateId", getTemplateIdFromCode(type))
    }
},[type, types])

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
}

function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}

function getTemplateIdFromCode(code){
    const result = types.find(type=> type.code === code)
    if(result){
        return result.id
    }
}

function getNameFromCode(code){
    const result = types.find(type=> type.code === code)
    if(result){
        return result.name
    }
}

    return(
        <div className={classes.containers} id="documentation-request-form">
                <div className={"grid-two-columns"}>
                        <TextBox label={"Nome"} labelMode="floating" key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} ></TextBox>
                        <TextBox label={"Apellidos"} labelMode="floating" key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} ></TextBox>            
                        <TextBox label={"Móvil"} labelMode="floating" key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} ></TextBox>
                        <TextBox label={"Correo electrónico"} labelMode="floating" key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} ></TextBox>                                  
                        <TextBox label={"DNI"} labelMode="floating" key={"dni"} name="dni" value={dataForm?.dni} onValueChanged={(e) => onChange("dni",e.value)} ></TextBox>
                        <SelectBox label={"Accesorio instalado por"} value={type} onValueChanged={(e) => {setType(e.value); onChange("templateCode", e.value); onChange("accesoryInstaller", getNameFromCode(e.value))}} valueExpr="code" displayExpr="name" placeholder="" dataSource={types}></SelectBox>                             
                </div>
                    <TextArea label={"Motivo ITV desfavorable"} labelMode="floating" key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} height={144}></TextArea>
               
        </div>
    )
}

export { ItvForm }